import type { PropsWithChildren } from "react";
import { AddRiskModalWithPolicy } from "./add-risk-bulk-modal-with-policy";

interface AddRiskModalProps extends PropsWithChildren {
  selectedVideos: string[];
  onSuccess: () => void;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const AddRiskModal = (props: AddRiskModalProps) => <AddRiskModalWithPolicy {...props} />;
